import IbeConfig from '../Models/CMS/IbeConfig';
import { MapConfig } from '@ibe/components';
import { ApiGeoUnitFromJSON, ApiHotel } from '@ibe/api';
import { useExternalSearchParams } from '../Config/ExternalParamsContext';
import getExternalConfig from '../Config/externalConfigs';
import { Marker } from '../Components/ParkMap/MapsInterfaces';

const getParkLocationFromIbeConfigurationOld = (
  //OLDMAP to be removed
  localIbeConfig?: IbeConfig,
  translationsUrl?: string
): Marker[] => {
  const parkIconUrl = `${translationsUrl || '.'}/Images/green-marker-icon.webp`;
  if (!localIbeConfig) {
    return [];
  }
  return [
    {
      geoData: {
        location: localIbeConfig.parkName,
        latitude: localIbeConfig.latitude,
        longitude: localIbeConfig.longitude,
        geoUnit: ApiGeoUnitFromJSON(null)
      },
      openPopup: true,
      name: localIbeConfig.parkName,
      iconUrl: parkIconUrl
    }
  ];
};

const getCustomHotelMarkerIconOld = (translationsUrl?: string) => {
  //OLDMAP to be removed
  return `${translationsUrl || '.'}/Images/blue-marker-icon.webp`;
};

export const getCustomMapConfigOld = (ibeConfig?: IbeConfig, translationsUrl?: string) => {
  //OLDMAP to be removed
  return {
    additionalMarkers: getParkLocationFromIbeConfigurationOld(ibeConfig, translationsUrl),
    showMapFullScreenOnClick: true,
    customMarkersImageUrl: getCustomHotelMarkerIconOld(translationsUrl),
    zoomSnap: 0.1,
    pad: 4,
    zoomMap: 8
  };
};

const getParkLocationFromIbeConfiguration = (localIbeConfig?: IbeConfig): Marker[] => {
  if (!localIbeConfig) {
    return [];
  }
  return [
    {
      geoData: {
        location: localIbeConfig.parkName,
        latitude: localIbeConfig.latitude,
        longitude: localIbeConfig.longitude,
        geoUnit: ApiGeoUnitFromJSON(null)
      },
      name: localIbeConfig.parkName,
      iconUrl: getParkIcon(),
      isPark: true
    }
  ];
};

export const getMapConfig = (hotelList: ApiHotel[], ibeConfig?: IbeConfig): MapConfig => {
  let markers: Marker[] = hotelList
    .filter(hotel => hotel.geoAssignment)
    .map(hotel => ({
      geoData: hotel.geoAssignment,
      name: hotel.name || '',
      image: getHotelImage(hotel),
      distance: hotel?.distance,
      id: hotel?.id,
      iconUrl: getHotelIcon(hotel?.distance?.floatDistance),
      price: hotel.price
    }));
  markers = markers.concat(getParkLocationFromIbeConfiguration(ibeConfig));

  return {
    markers: markers,
    zoomSnap: 0.1,
    pad: 0.1
  };
};

export const getHotelMapConfig = (hotel: ApiHotel, ibeConfig?: IbeConfig): MapConfig => {
  let markers: Marker[] = [];
  markers.push({
    geoData: hotel.geoAssignment,
    name: hotel.name || '',
    image: getHotelImage(hotel),
    distance: hotel?.distance,
    id: hotel?.id,
    iconUrl: getHotelIcon(hotel?.distance?.floatDistance),
    price: hotel.price
  });
  markers = markers.concat(getParkLocationFromIbeConfiguration(ibeConfig));
  return {
    markers: markers,
    centerMap: { lat: hotel.geoAssignment.latitude, lng: hotel.geoAssignment.longitude },
    zoomSnap: 0.1
  };
};

const getHotelImage = (hotel: ApiHotel) => {
  if (hotel?.media?.mainImage?.small) {
    return hotel?.media?.mainImage;
  }
  if (hotel?.media?.images?.length > 0) {
    return hotel?.media?.images.find(image => image.small);
  }
};

const getTranslationsUrl = () => {
  const externalSearchParams = useExternalSearchParams();
  const translationsUrl = externalSearchParams
    ? getExternalConfig(externalSearchParams, {})?.translationsUrl
    : '';
  return translationsUrl;
};

const getHotelIcon = (distance?: number, floatDistance?: number) => {
  const resortHotelIconUrl = `${getTranslationsUrl() || '.'}/Images/map/icons/blue-marker-icon.svg`;
  const partnerHotelIconUrl = `${
    getTranslationsUrl() || '.'
  }/Images/map/icons/grey-marker-icon.svg`;
  return (distance && distance > 0) || (floatDistance && floatDistance > 0)
    ? partnerHotelIconUrl
    : resortHotelIconUrl;
};

const getParkIcon = () => {
  return `${getTranslationsUrl() || '.'}/Images/map/icons/yellow-marker-icon.svg`;
};
